module.exports = __webpack_public_path__ + "static/img/car_mobile_renting.9.c33268eb.png";